export const INVENTORY_DATA = {
  "Furniture & Seating": [
    { id: "f1", name: "Standard Chair", price: 50 },
    { id: "f2", name: "Dining Table Chair", price: 60 },
    { id: "f3", name: "Office Chair", price: 120 },
    { id: "f4", name: "Rocking Chair", price: 200 }
  ],
  "Tables": [
    { id: "t1", name: "Teapoy / Center Table", price: 150 },
    { id: "t2", name: "Dining Table", price: 450 },
    { id: "t3", name: "Coffee Table", price: 130 }
  ],
  "Sofa Selection": [
    { id: "s1", name: "Single Seater Sofa", price: 250 },
    { id: "s2", name: "Double Seater Sofa", price: 450 },
    { id: "s3", name: "Big Size / L-Shape Sofa", price: 700 },
    { id: "s4", name: "Foldable Sofa-Bed", price: 500 }
  ],
  "Beds & Mattress": [
    { id: "b1", name: "Single Bed", price: 350 },
    { id: "b2", name: "Double Bed", price: 600 },
    { id: "b3", name: "Master Bed (King/Queen)", price: 900 }
  ],
  "Storage & Cabinets": [
    { id: "c1", name: "Shoe Rack", price: 120 },
    { id: "c2", name: "Dressing Table", price: 300 },
    { id: "c3", name: "Book Shelf", price: 250 },
    { id: "c4", name: "Mandir / Puja Unit", price: 200 },
    { id: "c5", name: "Iron Trunk / Chest", price: 350 },
    { id: "c6", name: "Wardrobe (Small)", price: 400 },
    { id: "c7", name: "Wardrobe (Medium)", price: 650 },
    { id: "c8", name: "Wardrobe (Large)", price: 950 }
  ],
  "Electronics & Computers": [
    { id: "e1", name: "TV (LED/LCD)", price: 350 },
    { id: "e2", name: "TV Stand / Unit", price: 200 },
    { id: "e3", name: "Computer Desktop System", price: 300 },
    { id: "e4", name: "Computer / Study Table", price: 200 }
  ],
  "Cooling & Fans": [
    { id: "ac1", name: "Split AC", price: 700 },
    { id: "ac2", name: "Window AC", price: 500 },
    { id: "fn1", name: "Air Cooler", price: 350 },
    { id: "fn2", name: "Ceiling Fan", price: 80 },
    { id: "fn3", name: "Table Fan", price: 60 }
  ],
  "Kitchen & Appliances": [
    { id: "k1", name: "Fridge / Refrigerator", price: 600 },
    { id: "k2", name: "Gas Stove", price: 120 },
    { id: "k3", name: "Gas Cylinder", price: 100 },
    { id: "k4", name: "Microwave Oven", price: 200 },
    { id: "k5", name: "Water Purifier (RO)", price: 150 },
    { id: "k6", name: "Washing Machine", price: 500 },
    { id: "k7", name: "Geyser", price: 150 },
    { id: "k8", name: "Inverter & Battery", price: 400 }
  ],
  "Utility & Decor": [
    { id: "u1", name: "Decorative Item / Showpiece", price: 50 },
    { id: "u2", name: "Lamp / Light Stand", price: 120 },
    { id: "u3", name: "Dish Antenna", price: 150 },
    { id: "u4", name: "Water Tank", price: 600 },
    { id: "p1", name: "Small Plant Pot", price: 40 },
    { id: "p2", name: "Medium Plant Pot", price: 90 },
    { id: "bx1", name: "Carton / Packing Box", price: 50 }
  ],
  "Vehicles": [
    { id: "v1", name: "Bicycle / Cycle", price: 200 },
    { id: "v2", name: "Two Wheeler (Bike/Scooter)", price: 1500 },
    { id: "v3", name: "Four Wheeler (Car)", price: 6000 }
  ]
};